import ReactRootProviders from '@app/contexts/providers/ReactRootProviders';
import { RouteToDestinations } from '@app/types/angular';
import { angularRouteTo } from '@app/utils/angular';
import EmptyStatePNG from '@assets/images/dashboard/manage-shipments/empty-state-image.png';
import { Button } from 'easyship-components';
import { ArrowRight } from 'easyship-components/icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function EmptyStateInner() {
  const status = window.location.pathname.split('/').pop();

  return (
    <div className="py-[124px] flex flex-col items-center">
      {status === 'shipments' && (
        <>
          <img src={EmptyStatePNG} alt="boxes" width="465" height="96" />
          <p className="mt-16 mb-5 text-ink-900 text-[24px]/[150%]">
            <FormattedMessage id="shipments.list.empty.none-purchased" />
          </p>
          <p className="max-w-[460px] text-center text-ink-900 mb-16">
            <FormattedMessage id="shipments.list.empty.none-purchased-sub" />
          </p>
          <Button
            color="primary"
            leftIcon={<ArrowRight className="scale-x-[-1]" />}
            className="min-w-[304px] font-bold h-[60px] rounded text-lg"
            onClick={() => {
              angularRouteTo(RouteToDestinations.Advanced);
            }}
          >
            <FormattedMessage id="shipments.list.empty.start" />
          </Button>
        </>
      )}
      {(status === 'pending' || status === 'rejected' || status === 'to_download') && (
        <>
          <p className="mt-16 mb-8 text-ink-900 text-[24px]/[150%]">
            <FormattedMessage id={`shipments.list.empty.${status}`} />
          </p>
          <Button
            className="min-w-[243px] font-bold h-[60px] rounded text-lg"
            onClick={() =>
              angularRouteTo(
                RouteToDestinations.Shipments,
                {
                  sectionName: 'shipments-all',
                  page: 1,
                  query: { scope: 'shipments_all' },
                  view_id: null,
                },
                { reload: true }
              )
            }
          >
            <FormattedMessage id="shipments.list.buttons.view-all" />
          </Button>
        </>
      )}
    </div>
  );
}

export function ShipmentsEmptyState() {
  return (
    <ReactRootProviders>
      <EmptyStateInner />
    </ReactRootProviders>
  );
}

export default ShipmentsEmptyState;
